module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('popover-box', {
    ref: "popover",
    staticClass: "form-popover",
    attrs: {
      "parent": _vm.parent,
      "direction": _vm.direction
    }
  }, [_vm._t("default"), _vm._v(" "), _c('div', [_c('action-button', {
    staticClass: "form-popover__submit-button",
    attrs: {
      "label": "Submit",
      "color": "secondary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.clickedSubmit.apply(null, arguments)
      }
    }
  })], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7fa66ea9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/common/popover/forms/FormPopover.vue
// module id = 1965
// module chunks = 0